// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"6acebbf6","203":"4cd62844","620":"7a663de3","693":"69947c65","712":"f6cb1529","787":"ffd9c12e","875":"9fcd1dd2","919":"a4cb8fb4"}[chunkId] + ".chunk.js";
};